import { useMutation } from '@tanstack/react-query';
import { enrollmentClient } from '../clients';
import { IStartEnrollment } from '../models';

export function useStartEnrollment() {
    return useMutation({
        mutationFn: (enrollment: IStartEnrollment) => enrollmentClient.startEnrollment(enrollment),
    });
}
